import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsThunderbirdComponent } from './simple-icons-thunderbird.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsThunderbirdComponent ],
    exports:      [ SimpleIconsThunderbirdComponent ],
    bootstrap:    []
})
export class SimpleIconsThunderbirdModule {}
